import React, { useMemo } from 'react'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { mutualTheme } from '~/utils/theme'
import { CircledText } from '~/components/CircledText'
import { SubStep } from './components'
import clsx from 'clsx'

export type StepIndicatorProps = {
  currentPage: number
}

const useStyles = makeStyles({
  circledText: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: mutualTheme.spacing(5)
  },
  subStepSpacing: {
    marginBottom: mutualTheme.spacing(3)
  },
  subTitleText: {
    marginTop: 16,
    marginBottom: 16,
    marginLeft: 80,
    color: '#9B9B9B'
  }
})

export const StepIndicator = (props: StepIndicatorProps) => {
  const { currentPage } = props
  const classes = useStyles()

  const renderResult = useMemo(() => {
    return (
      <Box>
        <Box className={classes.circledText}>
          <CircledText
            text='IDENTIFICAÇÃO'
            circleText='1'
            disabled={false}
            finished={currentPage > 0}
          />
        </Box>
        <Box className={classes.circledText}>
          <CircledText
            text='SUA EMPRESA'
            circleText='2'
            disabled={currentPage < 1}
            finished={currentPage > 1}
          />
        </Box>
        <Box className={classes.circledText}>
          <CircledText
            text='SEU EMPRÉSTIMO'
            circleText='3'
            disabled={currentPage < 2}
            finished={currentPage > 2}
          />
        </Box>

        <Box className={clsx(classes.circledText, {
          [classes.subStepSpacing]: currentPage >= 3 && currentPage <= 4
        })}>
          <CircledText
            text='SEUS CONTATOS'
            circleText='4'
            disabled={currentPage < 3}
            finished={currentPage > 4}
          />
        </Box>
        {currentPage >= 3 && currentPage < 5 && <SubStep currentPage={currentPage} subStepIndex={3} title='Endereço' />}
        {currentPage >= 3 && currentPage < 5 && <SubStep currentPage={currentPage} subStepIndex={4} title='Redes Sociais' />}
        <Box className={classes.circledText}>
          <CircledText
            text='CRIAR CONTA'
            circleText='5'
            disabled={currentPage < 5}
            finished={currentPage > 5}
          />
        </Box>
      </Box>
    )
  }, [currentPage])

  return (
    <>
      {renderResult}
    </>
  )
}
